import { HStack, Icon, LucideIcon, Text, VStack } from '@skin-seoul/design-system';
import { useProductService, useRegionCurrency } from '@skin-seoul/service';
import React from 'react';
import MobileProductComparisionSummarySkeleton from './MobileProductComparisionSummary.skeleton';
import { useProductCompareContext } from '../context';
type MobileProductComparisionSummaryProps = {
  orgProductId?: number;
  altProductId?: number;
};
const MobileProductComparisionSummary = ({
  orgProductId,
  altProductId
}: MobileProductComparisionSummaryProps) => {
  const {
    useGetListRecommendations
  } = useProductService();
  const {
    currency
  } = useRegionCurrency();
  const {
    selectedFilter
  } = useProductCompareContext();
  const {
    data: recommendationsData
  } = useGetListRecommendations({
    productId: orgProductId,
    currency,
    filter: selectedFilter
  });
  const orgProduct = recommendationsData?.original;
  const altProduct = recommendationsData?.recommendations?.find(rec => (rec.parentProductId ?? rec.productId) === altProductId);
  if (!orgProduct || !altProduct) {
    return null;
  }
  return <HStack width="full" gap={2} alignItems="stretch" data-sentry-element="HStack" data-sentry-component="MobileProductComparisionSummary" data-sentry-source-file="MobileProductComparisionSummary.tsx">
      <VStack flex={1} alignItems="start" backgroundColor="white" borderRadius="8px" padding={2} data-sentry-element="VStack" data-sentry-source-file="MobileProductComparisionSummary.tsx">
        <Text textStyle="paragraph.xsmall" fontWeight="medium" color="neutral.400" data-sentry-element="Text" data-sentry-source-file="MobileProductComparisionSummary.tsx">
          Recently Viewed
        </Text>
        <VStack gap={2.5} alignItems="start" flex={1} width="full" data-sentry-element="VStack" data-sentry-source-file="MobileProductComparisionSummary.tsx">
          <VStack gap={1} alignItems="start" flex={1} data-sentry-element="VStack" data-sentry-source-file="MobileProductComparisionSummary.tsx">
            {orgProduct.efficacy.slice(0, 2).map((efficacyItem, idx) => <HStack key={idx} gap={1}>
                <Icon color="neutral.400" boxSize={3}>
                  <LucideIcon name="Check" />
                </Icon>
                <Text textStyle="label.small" fontWeight="regular" color="neutral.600" as="label" textTransform="capitalize">
                  {efficacyItem}
                </Text>
              </HStack>)}
          </VStack>
        </VStack>
      </VStack>
      <VStack flex={1} alignItems="start" backgroundColor="primary.75" borderRadius="8px" padding={2} data-sentry-element="VStack" data-sentry-source-file="MobileProductComparisionSummary.tsx">
        <Text textStyle="paragraph.xsmall" fontWeight="medium" color="primary.600" data-sentry-element="Text" data-sentry-source-file="MobileProductComparisionSummary.tsx">
          AI Choice
        </Text>
        <VStack gap={2.5} alignItems="start" flex={1} width="full" data-sentry-element="VStack" data-sentry-source-file="MobileProductComparisionSummary.tsx">
          <VStack gap={1} alignItems="start" flex={1} data-sentry-element="VStack" data-sentry-source-file="MobileProductComparisionSummary.tsx">
            {altProduct.efficacy.slice(0, 2).map((efficacyItem, idx) => <HStack key={idx} gap={1}>
                <Icon color="primary.600" boxSize={3}>
                  <LucideIcon name="Check" />
                </Icon>
                <Text textStyle="label.small" fontWeight="regular" color="neutral.600" as="label" textTransform="capitalize">
                  {efficacyItem}
                </Text>
              </HStack>)}
          </VStack>
        </VStack>
      </VStack>
    </HStack>;
};
MobileProductComparisionSummary.Skeleton = MobileProductComparisionSummarySkeleton;
export default MobileProductComparisionSummary;